import {useLocalStorage} from "@uidotdev/usehooks";

export const useFavoriteCurrency = () => {
  return useLocalStorage('favoriteCurrency');
}